import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import './NewUser.scss';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import {useHistory} from 'react-router';
import actions from '../../../redux/actions';
import * as yup from 'yup';
import {CuitInput, CustomSelect} from '../../../common/components/CustomInputs/CustomInputs';
import _ from 'lodash';
import plusSvg from '../../../images/plus.svg';
import minusSvg from '../../../images/minus.svg';
import Loading from '../../../common/components/Loading/Loading';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import {deleteExtraSpaces} from '../../../utils/util';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
export const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const NewPhone = ({index, deleteFunc, formik}) => {
    useEffect(()=>{
        formik.values.phoneNumbers[index+1] = {type: 'PERSONAL', number: ''};
        // eslint-disable-next-line
    }, []);

    return (
        <>
        <div className="eu-div-input">
            <select className="eu-input-l w20" placeholder={'Cateoria'}
                name={`phoneNumbers[${index+1}].type`}
                value={formik.values.phoneNumbers[index+1]?.type || 'OFFICE' }
                onChange={formik.handleChange}
            >
                <option value="PERSONAL">Personal</option>
                <option value="OFFICE">Oficina</option>
                <option value="OTHER">Otro</option>
            </select>
            <input className="eu-input-m" placeholder={'Numero'}
                name={`phoneNumbers[${index+1}].number`}
                value={formik.values.phoneNumbers[index+1]?.number}
                onChange={formik.handleChange}
                required
            />
            <Ebutton classNameButton="eu-input-br" type="button" text={<img src={minusSvg} alt={'minus'}/>} onClick={deleteFunc} />
        </div>
        <div className="eu-div-input">
            <InputErrorMessage formik={formik} name={`phoneNumbers[${index+1}].number`} className='eu-input-l' />
        </div>
        </>
    );
};

const NewUser = (props) => {
    const {
        name,
        userInfo,
        getBranches,
        getBranchesProviders,
        branches,
        branchesProviders,
        setProviderSelected,
        addProvider,
        newProviderState,
        cleanNewProviderState,
        getBranchesState,
        getBranchesProvidersState,
        cleanBranches,
        cleanProvidersBranches,
        showSidebar,
    } = props;
    const validationSchema =
        yup.object({
            name: yup
                .string('Ingrese nombre')
                .required('Ingrese nombre'),
            cuitOrCuil: yup
                .string('Ingrese cuit')
                .matches(/^[0-9]{2}-[0-9]{8}-[0-9]$/, 'Cuit Inválido')
                .required('Ingrese cuit'),
            email: yup
                .string('Ingrese email')
                .email('Email inválido')
                .required('Ingrese email'),
            salesforceProviderId: yup
                .string('Seleccione un prestador')
                .required('Seleccione un prestador'),
            salesforceBranchId: yup.string().when('type', {
                is: 'PROVIDER_USER',
                then: yup.string('Seleccione una sede')
                    .required('Seleccione una sede'),
                otherwise: yup.string(),
            }),
            phoneNumbers: yup.array().of(
                yup.object().shape({
                    type: yup
                        .string('Ingrese tipo')
                        .required('Ingrese tipo'),
                    number: yup.string().when('type', {
                        is: 'OTHER',
                        then: yup.string('Ingrese número')
                            .required('Ingrese número'),
                        otherwise: yup.string('Ingrese número')
                            .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                                'Número Inválido (No olvide colocar el código de área)')
                            .required('Ingrese número')}),
                }),
            )
                .required('Teléfonos requeridos'),
            });
    const history = useHistory();
    const formik = useFormik({
        initialValues: {
            type: 'PROVIDER_USER',
            name: '',
            cuitOrCuil: '',
            email: '',
            salesforceProviderId: userInfo?.salesforceProviderId || '',
            salesforceBranchId: userInfo?.salesforceBranchId || '',
            phoneNumbers: [{type: 'PERSONAL', number: ''}],
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                type: values.type==='PROVIDER_USER'? 'user' : 'admin',
                user: values.type==='PROVIDER_USER' ? _.omit( values, ['type'] ) : _.omit( values, ['type', 'salesforceBranchId'] ),
            };
            setProviderSelected(values);
            addProvider(body);
        },
    });

    useEffect(
        () => {
            if ( newProviderState.success ) {
                cleanNewProviderState();
                history.goBack();
            };
            // eslint-disable-next-line
        }, [newProviderState],
    );

    useEffect(()=>{
        cleanBranches();
        cleanProvidersBranches();
        // solo para admins, si es provider admin solo deberia ver su sede
        getBranches();
        // eslint-disable-next-line
    }, []);

    useEffect(()=>{
        formik.resetForm({values: {...formik.values, salesforceBranchId: ''}});
        if (formik.values.type==='PROVIDER_USER' && formik.values.salesforceProviderId) {
            console.log('getting branches providers')

            getBranchesProviders(formik.values.salesforceProviderId);
        }
        console.log("current",branchesProvidersOptions.current);

        // eslint-disable-next-line
    }, [formik.values.salesforceProviderId]);

    useEffect(()=> {
        setBranchesOptions(branches?.map((branch) => {
            if (branch.providerId === 'a1l2K000005fIfrQAE') {
                branch.fullName = 'Prestador sin sede';
            }
            return {value: branch.providerId.toString(), label: deleteExtraSpaces(branch.fullName)};
        }));
    }, [branches, getBranchesState.success]);

    useEffect(()=> {
        branchesProvidersOptions.current = branchesProviders?.map((branch) => {
            return {value: branch.branchId.toString(), label: deleteExtraSpaces(branch.fullName)};
        });
        formik.setFieldValue('salesforceBranchId', branchesProvidersOptions?.current[0]?.value);
        // eslint-disable-next-line
    }, [branchesProviders, getBranchesProvidersState.success]);

    const [nextPhone, setNextPhone] = useState(0);
    const [phoneKeys, setPhoneKeys] = useState([]);
    const [branchesOptions, setBranchesOptions] = useState([]);
    const branchesProvidersOptions = useRef([]);

    const addPhone = () => {
        setPhoneKeys( [...phoneKeys, nextPhone] );
        setNextPhone( nextPhone+1 );
    };

    const deletePhone = (key, index=null) => {
        if (index) formik.values.phoneNumbers.splice(index, 1);
        setPhoneKeys( phoneKeys.filter( (k) => k!==key ) );
    };

    return ( getBranchesState.success ?
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}
        style={{backgroundColor: 'transparent', margin: '10px', padding: '10px'}}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">NUEVO USUARIO DE PRESTADOR</p>
                        <hr id="id-hr"/>
                    </div>
                </div>

                <div className="ul-div-form">

                    <form className="eu-form" onSubmit={formik.handleSubmit}>
                        <input type="hidden" name="password" value={formik.values.password} onChange={formik.handleChange} />
                        <input type="hidden" name="zipCode" value={formik.values.zipCode} onChange={formik.handleChange} />
                        <div className="eu-radio-container">
                            <input
                                type='radio'
                                value={'PROVIDER_ADMIN'}
                                onChange={formik.handleChange}
                                name='type'
                                className="eu-radio"
                                checked={formik.values.type==='PROVIDER_ADMIN'}
                            /> Admin de prestador
                            <input
                                type='radio'
                                value={'PROVIDER_USER'}
                                onChange={formik.handleChange}
                                name='type'
                                className="eu-radio"
                                checked={formik.values.type==='PROVIDER_USER'}
                            /> Usuario de sede
                        </div>
                        <div className="eu-div-container">
                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">Nombre</text>
                                <text className="eu-text-s eu-f-label">CUIT/CUIL</text>
                            </div>
                            <div className="eu-div-input">
                                <input className="eu-input-l" name="name" value={formik.values.name}
                                    onChange={formik.handleChange}
                                />
                                <CuitInput className="eu-input-s" name="cuitOrCuil" value={formik.values.cuitOrCuil}
                                    onChange={formik.handleChange} />
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='name' className='eu-input-l' />
                                <InputErrorMessage formik={formik} name='cuitOrCuil' className='eu-input-s' />
                            </div>
                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">E-mail</text>
                                <text className="eu-text-s eu-f-label">Prestador</text>
                            </div>
                            <div className="eu-div-input">
                                <input
                                    className="eu-input-l" name="email" value={formik.values.email}
                                    onChange={formik.handleChange}
                                />
                                <CustomSelect
                                    name="salesforceProviderId"
                                    className='eu-input-s eu-select'
                                    onChange={(value)=>formik.setFieldValue('salesforceProviderId', value.value)}
                                    value={formik.values.salesforceProviderId}
                                    options={branchesOptions}
                                    isSearchable={true}
                                />
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='email' className='eu-input-l' />
                                <InputErrorMessage formik={formik} name='salesforceProviderId' className='eu-input-s' />
                            </div>
                            {formik.values.type==='PROVIDER_USER' &&
                                <>
                                    <div className="eu-div-input">
                                        <text className="eu-text-l eu-f-label">Sede</text>
                                    </div>
                                    <div className="eu-div-input">
                                        <CustomSelect
                                            name="salesforceBranchId"
                                            className='eu-input-l eu-select'
                                            onChange={(value)=>formik.setFieldValue('salesforceBranchId', value?.value)}
                                            value={formik.values.salesforceBranchId}
                                            options={branchesProvidersOptions.current}
                                            disabled={branchesProvidersOptions.current?.length === 0 || getBranchesProvidersState.loading}
                                            isSearchable={true}
                                            isClearable={true}
                                        />
                                    </div>
                                    <div className="eu-div-input">
                                        <InputErrorMessage formik={formik} name='salesforceBranchId' className='eu-input-l' />
                                    </div>
                                </>
                            }
                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">Teléfono</text>
                            </div>
                            <div className="eu-div-input">
                                <select className="eu-input-l w20" placeholder={'Cateoria'}
                                    name="phoneNumbers[0].type" value={formik.values.phoneNumbers[0]?.type}
                                    onChange={formik.handleChange}
                                >
                                    <option value="PERSONAL">Personal</option>
                                    <option value="OFFICE">Oficina</option>
                                    <option value="OTHER">Otro</option>
                                </select>
                                <input className="eu-input-m" placeholder={'Numero'}
                                    name="phoneNumbers[0].number" value={formik.values.phoneNumbers[0]?.number}
                                    onChange={formik.handleChange}
                                />
                                <Ebutton classNameButton="eu-input-br" type="button" text={<img src={plusSvg} alt={'plus'}/>} onClick={addPhone} />
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='phoneNumbers[0].number' className='eu-input-l' />
                            </div>
                            {phoneKeys.map( (k, i)=>
                                <NewPhone key={k} index={i} deleteFunc={()=>deletePhone(k, i+1)} formik={formik}/>,
                            )}
                            <Ebutton classNameButton="eu-btn" type="submit" text="CREAR USUARIO DE PRESTADOR"/>
                        </div>

                    </form>
                </div>
            </div>
        </div> :
        getBranchesState.loading ? <Loading className="ul-div-sect-table" /> :
            <CustomAlert text={'planes' || String(getBranchesState.error)} severity='error' />);
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    users: state.home.users,
    userInfo: state.login.userInfo,
    branches: state.home.branches,
    branchesProviders: state.home.branchesProviders,
    newProviderState: state.home.newProviderState,
    getBranchesState: state.home.getBranchesState,
    getBranchesProvidersState: state.home.getBranchesProvidersState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    getBranchesProviders: (id) => dispatch(actions.home.getBranchesProvidersRequest(id)),
    setProviderSelected: (providerSelected) => dispatch(actions.home.setProviderSelected(providerSelected)),
    addProvider: (provider) => dispatch(actions.home.addProviderRequest(provider)),
    cleanNewProviderState: () => dispatch(actions.home.cleanNewProviderState()),
    cleanGetBranchesState: () => dispatch(actions.home.cleanGetBranchesState()),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
});

NewUser.propTypes = {
    name: PropTypes.string,
};


export default connect(mapStateToProps, mapDispatchToProps)(NewUser);

